import { SnakeCaseKeys } from 'components/acquisitions/types/api';
import { toCamelCase, toSnakeCase } from 'components/brand/utils';
import { api } from 'controllers/network/apiClient';
import {
  CaslConfig,
  ComplianceContactInfo,
  FinancialIncentiveConfig,
  FinancialIncentiveConfigInput,
  LocalizedDisclaimerLinks,
  LocalizedDisclaimerLinksInput,
  OnThreadOptInToggleInfo,
  TexasQuietHoursToggleInfo,
} from './types';

export async function getComplianceContactInfo(): Promise<ComplianceContactInfo> {
  return api.get('/v2/shops/compliance_contact_info');
}

export async function initComplianceContactInfo(): Promise<ComplianceContactInfo> {
  return api.post('/v2/shops/compliance_contact_info');
}

export async function setComplianceContactInfo(
  data: ComplianceContactInfo,
): Promise<ComplianceContactInfo> {
  return api.put('/v2/shops/compliance_contact_info', data);
}

export async function getTexasQuietHoursInfo(): Promise<TexasQuietHoursToggleInfo> {
  return api.get('/v2/shops/compliance_texas_quiet_hours');
}

export async function setTexasQuietHoursInfo(
  data: TexasQuietHoursToggleInfo,
): Promise<TexasQuietHoursToggleInfo> {
  return api.post('/v2/shops/compliance_texas_quiet_hours', data);
}

export async function getFinancialIncentiveConfig(): Promise<FinancialIncentiveConfig> {
  const wire: SnakeCaseKeys<FinancialIncentiveConfig> = await api.get(
    '/v2/acquisition/financial_incentive_config',
  );
  return toCamelCase(wire) as FinancialIncentiveConfig;
}

export async function setFinancialIncentiveConfig(
  data: FinancialIncentiveConfigInput,
): Promise<FinancialIncentiveConfig> {
  const wireInput = toSnakeCase(
    data,
  ) as SnakeCaseKeys<FinancialIncentiveConfigInput>;
  const wire: SnakeCaseKeys<FinancialIncentiveConfig> = await api.put(
    '/v2/acquisition/financial_incentive_config',
    wireInput,
  );
  return toCamelCase(wire) as FinancialIncentiveConfig;
}

export async function getCaslConfig(): Promise<CaslConfig> {
  const wire: SnakeCaseKeys<CaslConfig> = await api.get(
    '/v2/acquisition/casl_config',
  );
  return toCamelCase(wire) as CaslConfig;
}

export async function setCaslConfig(data: CaslConfig): Promise<CaslConfig> {
  const wireInput = toSnakeCase(data) as SnakeCaseKeys<CaslConfig>;
  const wire: SnakeCaseKeys<CaslConfig> = await api.put(
    '/v2/acquisition/casl_config',
    wireInput,
  );
  return toCamelCase(wire) as CaslConfig;
}

export async function getLocalizedDisclaimerLinks(): Promise<LocalizedDisclaimerLinks> {
  const wire: SnakeCaseKeys<LocalizedDisclaimerLinks> = await api.get(
    '/v2/acquisition/localized_disclaimer_links',
  );
  return toCamelCase(wire) as LocalizedDisclaimerLinks;
}

export async function setLocalizedDisclaimerLinks(
  data: LocalizedDisclaimerLinksInput,
): Promise<LocalizedDisclaimerLinks> {
  const wireInput = toSnakeCase(
    data,
  ) as SnakeCaseKeys<LocalizedDisclaimerLinksInput>;
  const wire: SnakeCaseKeys<LocalizedDisclaimerLinks> = await api.put(
    '/v2/acquisition/localized_disclaimer_links',
    wireInput,
  );
  return toCamelCase(wire) as LocalizedDisclaimerLinks;
}

export async function getOnThreadOptInInfo(): Promise<OnThreadOptInToggleInfo> {
  return api.get('/v2/shops/compliance_on_thread_opt_in');
}

export async function setOnThreadOptInInfo(data: {
  onThreadOptInEnabled: boolean;
}): Promise<OnThreadOptInToggleInfo> {
  return api.post('/v2/shops/compliance_on_thread_opt_in', data);
}
